// extracted by mini-css-extract-plugin
export default {"Icon":"index_Icon__9b9eI"};